if (!customElements.get('mossa-footer-localization')) {
  customElements.define(
    'mossa-footer-localization',
    class MossaFooterLocalization extends HTMLElement {
      constructor() {
        super();
        this.trigger = this.querySelector('.mossa-footer-localization__trigger');
        this.panel = this.querySelector('.mossa-footer-localization__panel');
        this.trigger.addEventListener('click', this.togglePanel.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.addEventListener('keyup', this.onKeyUp.bind(this));
        this.querySelectorAll('.mossa-footer-localization__option').forEach((option) => {
          option.addEventListener('click', this.onOptionClick.bind(this));
        });
      }

      togglePanel() {
        const isOpen = this.trigger.getAttribute('aria-expanded') === 'true';
        this.setOpen(!isOpen);
      }

      setOpen(open) {
        this.trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        this.panel.toggleAttribute('hidden', !open);
      }

      onFocusOut(event) {
        if (!this.contains(event.relatedTarget)) {
          this.setOpen(false);
        }
      }

      onKeyUp(event) {
        if (event.code === 'Escape') {
          this.setOpen(false);
          this.trigger.focus();
        }
      }

      onOptionClick(event) {
        event.preventDefault();
        const form = event.currentTarget.closest('form');
        const input = form.querySelector('input[name="country_code"], input[name="locale_code"]');
        input.value = event.currentTarget.dataset.value;
        form.submit();
      }
    }
  );
}
